var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'score-float',
    {
      editable: (_vm.is_admin || _vm.is_owner) && _vm.editable,
      audited: _vm.a.score_get === -1,
      active: _vm.a.right,
      red: !_vm.a.right
    }
  ],attrs:{"data-item":_vm.a,"data-index":_vm.a.originIndex},on:{"click":function($event){(_vm.is_admin || _vm.is_owner) && _vm.editable ? _vm.editScore() : ''}}},[_c('img',{staticClass:"score-float-icon",attrs:{"src":_vm.a.score_get === -1 ? _vm.auditedIcon : _vm.a.right ? _vm.rightIcon : _vm.wrongIcon,"mode":"aspectFill"}}),_vm._v(" "),(_vm.a.score_get === -1)?[_vm._v("批改后出分")]:[_c('span',[_vm._v(_vm._s(_vm.a.right ? "答对" : "答错")+" 得")]),_vm._v(" "),_c('label',{staticClass:"score-float-input"},[_vm._v(_vm._s(_vm.a.score_get))]),_vm._v(" "),_c('span',[_vm._v("分")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036a818e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/scoreitem.vue
// module id = null
// module chunks = 